import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createCustomFilterActions } from './actions';
import { CustomFilterActions, CustomFilterState } from './types';

export const useCustomFilterStore = create<CustomFilterState & CustomFilterActions>()(
    immer((set, get, store) => ({
        customFilters: [],
        loading: false,
        selectedCustomFilter: null,
        loadingCustomFilter: false,
        error: undefined,
        ...createCustomFilterActions(set, get, store),
    })),
);
